package com.example.mystybag.core.resources

import dev.icerock.moko.graphics.Color
import dev.icerock.moko.resources.FontResource
import dev.icerock.moko.resources.ImageResource
import dev.icerock.moko.resources.ResourceContainer
import dev.icerock.moko.resources.ResourcePlatformDetails
import kotlin.String
import kotlin.collections.List

public actual object SRC {
  private val contentHash: String = "7cdb039af7215459e5f63fb6d7e241f6"

  public actual object images : ResourceContainer<ImageResource> {
    actual override val __platformDetails: ResourcePlatformDetails = ResourcePlatformDetails()

    public actual val finger_animation_25: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_25.png\")") as String, fileName =
        "finger_animation_25.png")

    public actual val sk_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/sk_flag.svg\")") as String, fileName = "sk_flag.svg")

    public actual val operation_executed_arrow_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/operation_executed_arrow_image.svg\")") as String, fileName =
        "operation_executed_arrow_image.svg")

    public actual val jcb_circle_logo: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/jcb_circle_logo.png\")") as String, fileName = "jcb_circle_logo.png")

    public actual val pdf_file_img: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/pdf_file_img.png\")") as String, fileName = "pdf_file_img.png")

    public actual val add_to_gpay_image_it: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_it.png\")") as String, fileName =
        "add_to_gpay_image_it.png")

    public actual val face_id_key: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/face_id_key.png\")") as String, fileName = "face_id_key.png")

    public actual val virtual_card_design_012: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/virtual_card_design_012.png\")") as String, fileName =
        "virtual_card_design_012.png")

    public actual val ee_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ee_flag.svg\")") as String, fileName = "ee_flag.svg")

    public actual val combobox_arrow_right_gray: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/combobox_arrow_right_gray.svg\")") as String, fileName =
        "combobox_arrow_right_gray.svg")

    public actual val chf_circle_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/chf_circle_flag.png\")") as String, fileName = "chf_circle_flag.png")

    public actual val bus_express_delivery: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bus_express_delivery.png\")") as String, fileName =
        "bus_express_delivery.png")

    public actual val added_to_icard_pay_image_dark_ro: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_dark_ro.png\")") as String, fileName =
        "added_to_icard_pay_image_dark_ro.png")

    public actual val illustration_side_menu_donations: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/illustration_side_menu_donations.png\")") as String, fileName =
        "illustration_side_menu_donations.png")

    public actual val al_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/al_flag.svg\")") as String, fileName = "al_flag.svg")

    public actual val add_to_icard_pay_image_el: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_icard_pay_image_el.png\")") as String, fileName =
        "add_to_icard_pay_image_el.png")

    public actual val banner_add_to_apple_pay: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/banner_add_to_apple_pay.png\")") as String, fileName =
        "banner_add_to_apple_pay.png")

    public actual val added_to_icard_pay_image_dark_es: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_dark_es.png\")") as String, fileName =
        "added_to_icard_pay_image_dark_es.png")

    public actual val cashterminal_pin_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/cashterminal_pin_icon.png\")") as String, fileName =
        "cashterminal_pin_icon.png")

    public actual val bag_location: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bag_location.svg\")") as String, fileName = "bag_location.svg")

    public actual val horizontal_dots_grey: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/horizontal_dots_grey.png\")") as String, fileName =
        "horizontal_dots_grey.png")

    public actual val adding_card_ro_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_ro_dark.png\")") as String, fileName =
        "adding_card_ro_dark.png")

    public actual val add_to_icard_pay_image_fr: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_icard_pay_image_fr.png\")") as String, fileName =
        "add_to_icard_pay_image_fr.png")

    public actual val cause_round_up_donate_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/cause_round_up_donate_icon.png\")") as String, fileName =
        "cause_round_up_donate_icon.png")

    public actual val mt_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/mt_flag.svg\")") as String, fileName = "mt_flag.svg")

    public actual val card_bottom_sheet_settings_btn: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/card_bottom_sheet_settings_btn.png\")") as String, fileName =
        "card_bottom_sheet_settings_btn.png")

    public actual val upload_file_camera_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/upload_file_camera_icon.svg\")") as String, fileName =
        "upload_file_camera_icon.svg")

    public actual val adding_card_es_light: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_es_light.png\")") as String, fileName =
        "adding_card_es_light.png")

    public actual val added_to_icard_pay_image_dark_de: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_dark_de.png\")") as String, fileName =
        "added_to_icard_pay_image_dark_de.png")

    public actual val add_bag_tag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_bag_tag.svg\")") as String, fileName = "add_bag_tag.svg")

    public actual val password_eye_open: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/password_eye_open.svg\")") as String, fileName =
        "password_eye_open.svg")

    public actual val bgn_circle_flag_small: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bgn_circle_flag_small.png\")") as String, fileName =
        "bgn_circle_flag_small.png")

    public actual val business_preview_2: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/business_preview_2.png\")") as String, fileName =
        "business_preview_2.png")

    public actual val master_card_circle_logo: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/master_card_circle_logo.png\")") as String, fileName =
        "master_card_circle_logo.png")

    public actual val ic_folder_plus: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_folder_plus.svg\")") as String, fileName = "ic_folder_plus.svg")

    public actual val hrk_circle_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/hrk_circle_flag.png\")") as String, fileName = "hrk_circle_flag.png")

    public actual val finger_animation_13: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_13.png\")") as String, fileName =
        "finger_animation_13.png")

    public actual val ic_el_circle: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_el_circle.svg\")") as String, fileName = "ic_el_circle.svg")

    public actual val added_to_icard_pay_image_bg: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_bg.png\")") as String, fileName =
        "added_to_icard_pay_image_bg.png")

    public actual val insurance_check: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/insurance_check.png\")") as String, fileName = "insurance_check.png")

    public actual val bank_transfer_icon_sepa_instant: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bank_transfer_icon_sepa_instant.png\")") as String, fileName =
        "bank_transfer_icon_sepa_instant.png")

    public actual val bank_details_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bank_details_icon.svg\")") as String, fileName =
        "bank_details_icon.svg")

    public actual val pending_request_giftcard_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/pending_request_giftcard_icon.svg\")") as String, fileName =
        "pending_request_giftcard_icon.svg")

    public actual val fee_transaction_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/fee_transaction_icon.png\")") as String, fileName =
        "fee_transaction_icon.png")

    public actual val icon_status_check: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/icon_status_check.svg\")") as String, fileName =
        "icon_status_check.svg")

    public actual val cz_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/cz_flag.svg\")") as String, fileName = "cz_flag.svg")

    public actual val cant_scan_confirmation_code_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/cant_scan_confirmation_code_image.png\")") as String, fileName =
        "cant_scan_confirmation_code_image.png")

    public actual val added_to_gpay_image_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_dark.png\")") as String, fileName =
        "added_to_gpay_image_dark.png")

    public actual val image_allergens: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/image_allergens.png\")") as String, fileName = "image_allergens.png")

    public actual val theme_phone_system: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/theme_phone_system.svg\")") as String, fileName =
        "theme_phone_system.svg")

    public actual val welcome_4: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/welcome_4.png\")") as String, fileName = "welcome_4.png")

    public actual val adding_card_fr_light: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_fr_light.png\")") as String, fileName =
        "adding_card_fr_light.png")

    public actual val default_circle_flag_small: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/default_circle_flag_small.png\")") as String, fileName =
        "default_circle_flag_small.png")

    public actual val linked_card_add_new_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/linked_card_add_new_icon.png\")") as String, fileName =
        "linked_card_add_new_icon.png")

    public actual val account_icon_001: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/account_icon_001.png\")") as String, fileName =
        "account_icon_001.png")

    public actual val illustration_side_menu_accounts: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/illustration_side_menu_accounts.png\")") as String, fileName =
        "illustration_side_menu_accounts.png")

    public actual val add_to_gpay_image_dark_de: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_dark_de.png\")") as String, fileName =
        "add_to_gpay_image_dark_de.png")

    public actual val account_funding_transaction_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/account_funding_transaction_icon.png\")") as String, fileName =
        "account_funding_transaction_icon.png")

    public actual val gr_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/gr_flag.svg\")") as String, fileName = "gr_flag.svg")

    public actual val icon_pending_clock: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/icon_pending_clock.svg\")") as String, fileName =
        "icon_pending_clock.svg")

    public actual val ic_plus_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_plus_icon.svg\")") as String, fileName = "ic_plus_icon.svg")

    public actual val icard_welcome_image_banner: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/icard_welcome_image_banner.png\")") as String, fileName =
        "icard_welcome_image_banner.png")

    public actual val usd_circle_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/usd_circle_flag.png\")") as String, fileName = "usd_circle_flag.png")

    public actual val alert_orange_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/alert_orange_fill_icon.svg\")") as String, fileName =
        "alert_orange_fill_icon.svg")

    public actual val safety_online_purchase_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/safety_online_purchase_icon.svg\")") as String, fileName =
        "safety_online_purchase_icon.svg")

    public actual val add_to_gpay_image_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_dark.png\")") as String, fileName =
        "add_to_gpay_image_dark.png")

    public actual val adding_card_ro_light: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_ro_light.png\")") as String, fileName =
        "adding_card_ro_light.png")

    public actual val czk_circle_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/czk_circle_flag.png\")") as String, fileName = "czk_circle_flag.png")

    public actual val insufficient_funds_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/insufficient_funds_image.png\")") as String, fileName =
        "insufficient_funds_image.png")

    public actual val added_to_gpay_image_nl: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_nl.png\")") as String, fileName =
        "added_to_gpay_image_nl.png")

    public actual val split_bill: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/split_bill.svg\")") as String, fileName = "split_bill.svg")

    public actual val eye_on_outline_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/eye_on_outline_icon.svg\")") as String, fileName =
        "eye_on_outline_icon.svg")

    public actual val ic_check_circle_blue: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_check_circle_blue.png\")") as String, fileName =
        "ic_check_circle_blue.png")

    public actual val nav_favorites: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/nav_favorites.svg\")") as String, fileName = "nav_favorites.svg")

    public actual val protect_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/protect_icon.svg\")") as String, fileName = "protect_icon.svg")

    public actual val add_to_gpay_image_dark_es: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_dark_es.png\")") as String, fileName =
        "add_to_gpay_image_dark_es.png")

    public actual val info_hint_icon_blue: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/info_hint_icon_blue.png\")") as String, fileName =
        "info_hint_icon_blue.png")

    public actual val add_to_gpay_image_dark_ro: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_dark_ro.png\")") as String, fileName =
        "add_to_gpay_image_dark_ro.png")

    public actual val bank_transfer_status_processing: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bank_transfer_status_processing.png\")") as String, fileName =
        "bank_transfer_status_processing.png")

    public actual val home_top_pick_heart: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/home_top_pick_heart.svg\")") as String, fileName =
        "home_top_pick_heart.svg")

    public actual val qr_shimmer: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/qr_shimmer.png\")") as String, fileName = "qr_shimmer.png")

    public actual val mol_trash_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/mol_trash_icon.svg\")") as String, fileName = "mol_trash_icon.svg")

    public actual val prepaid_icard_white: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/prepaid_icard_white.png\")") as String, fileName =
        "prepaid_icard_white.png")

    public actual val linked_card_maestro_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/linked_card_maestro_icon.png\")") as String, fileName =
        "linked_card_maestro_icon.png")

    public actual val card_status_sent: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/card_status_sent.png\")") as String, fileName =
        "card_status_sent.png")

    public actual val activity_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/activity_fill_icon.svg\")") as String, fileName =
        "activity_fill_icon.svg")

    public actual val search_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/search_icon.svg\")") as String, fileName = "search_icon.svg")

    public actual val icon_sort: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/icon_sort.svg\")") as String, fileName = "icon_sort.svg")

    public actual val rs_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/rs_flag.svg\")") as String, fileName = "rs_flag.svg")

    public actual val loyalty_card_000: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/loyalty_card_000.png\")") as String, fileName =
        "loyalty_card_000.png")

    public actual val adding_card_el_light: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_el_light.png\")") as String, fileName =
        "adding_card_el_light.png")

    public actual val cash_withdrawal_transaction_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/cash_withdrawal_transaction_icon.png\")") as String, fileName =
        "cash_withdrawal_transaction_icon.png")

    public actual val success_confirmation_code_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/success_confirmation_code_image.png\")") as String, fileName =
        "success_confirmation_code_image.png")

    public actual val add_to_gpay_image_de: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_de.png\")") as String, fileName =
        "add_to_gpay_image_de.png")

    public actual val rating_star_yellow: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/rating_star_yellow.png\")") as String, fileName =
        "rating_star_yellow.png")

    public actual val document_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/document_fill_icon.svg\")") as String, fileName =
        "document_fill_icon.svg")

    public actual val navigation_search: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/navigation_search.svg\")") as String, fileName =
        "navigation_search.svg")

    public actual val map_pin_not_clicked: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/map_pin_not_clicked.svg\")") as String, fileName =
        "map_pin_not_clicked.svg")

    public actual val trustly_logo: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/trustly_logo.png\")") as String, fileName = "trustly_logo.png")

    public actual val settings_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/settings_fill_icon.svg\")") as String, fileName =
        "settings_fill_icon.svg")

    public actual val vpay_circle_logo: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/vpay_circle_logo.png\")") as String, fileName =
        "vpay_circle_logo.png")

    public actual val benefit_virtual_card_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/benefit_virtual_card_fill_icon.svg\")") as String, fileName =
        "benefit_virtual_card_fill_icon.svg")

    public actual val ron_circle_flag_small: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ron_circle_flag_small.png\")") as String, fileName =
        "ron_circle_flag_small.png")

    public actual val chrono_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/chrono_icon.svg\")") as String, fileName = "chrono_icon.svg")

    public actual val added_to_icard_pay_image_nl: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_nl.png\")") as String, fileName =
        "added_to_icard_pay_image_nl.png")

    public actual val merchant_registration_success_illustration: ImageResource =
        ImageResource(fileUrl =
        js("require(\"./images/merchant_registration_success_illustration.png\")") as String,
        fileName = "merchant_registration_success_illustration.png")

    public actual val bank_transfer_status_declined: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bank_transfer_status_declined.png\")") as String, fileName =
        "bank_transfer_status_declined.png")

    public actual val adding_card_bg_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_bg_dark.png\")") as String, fileName =
        "adding_card_bg_dark.png")

    public actual val upload_document_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/upload_document_fill_icon.svg\")") as String, fileName =
        "upload_document_fill_icon.svg")

    public actual val card_tab_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/card_tab_icon.svg\")") as String, fileName = "card_tab_icon.svg")

    public actual val tap_n_pay_white: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/tap_n_pay_white.png\")") as String, fileName = "tap_n_pay_white.png")

    public actual val welcome_6: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/welcome_6.png\")") as String, fileName = "welcome_6.png")

    public actual val donation_transaction_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/donation_transaction_icon.png\")") as String, fileName =
        "donation_transaction_icon.png")

    public actual val minus_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/minus_fill_icon.svg\")") as String, fileName = "minus_fill_icon.svg")

    public actual val contactless_state_2: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/contactless_state_2.png\")") as String, fileName =
        "contactless_state_2.png")

    public actual val barcode_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/barcode_icon.png\")") as String, fileName = "barcode_icon.png")

    public actual val ic_folder: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_folder.svg\")") as String, fileName = "ic_folder.svg")

    public actual val card_scheme_logo_visa: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/card_scheme_logo_visa.svg\")") as String, fileName =
        "card_scheme_logo_visa.svg")

    public actual val combobox_arrow_down_gray: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/combobox_arrow_down_gray.svg\")") as String, fileName =
        "combobox_arrow_down_gray.svg")

    public actual val watch_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/watch_fill_icon.svg\")") as String, fileName = "watch_fill_icon.svg")

    public actual val visa_prepaid_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/visa_prepaid_dark.png\")") as String, fileName =
        "visa_prepaid_dark.png")

    public actual val added_to_icard_pay_image_dark_it: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_dark_it.png\")") as String, fileName =
        "added_to_icard_pay_image_dark_it.png")

    public actual val insurance_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/insurance_icon.png\")") as String, fileName = "insurance_icon.png")

    public actual val navigation_check: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/navigation_check.svg\")") as String, fileName =
        "navigation_check.svg")

    public actual val settings_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/settings_icon.svg\")") as String, fileName = "settings_icon.svg")

    public actual val arrow_back: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/arrow_back.svg\")") as String, fileName = "arrow_back.svg")

    public actual val card_placeholder: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/card_placeholder.png\")") as String, fileName =
        "card_placeholder.png")

    public actual val add_to_gpay_image_ro: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_ro.png\")") as String, fileName =
        "add_to_gpay_image_ro.png")

    public actual val shopping_discounts_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/shopping_discounts_icon.png\")") as String, fileName =
        "shopping_discounts_icon.png")

    public actual val share_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/share_icon.svg\")") as String, fileName = "share_icon.svg")

    public actual val add_to_gpay_image_es: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_es.png\")") as String, fileName =
        "add_to_gpay_image_es.png")

    public actual val no_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/no_flag.svg\")") as String, fileName = "no_flag.svg")

    public actual val image_authorize_activity_code: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/image_authorize_activity_code.png\")") as String, fileName =
        "image_authorize_activity_code.png")

    public actual val ic_de_circle: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_de_circle.svg\")") as String, fileName = "ic_de_circle.svg")

    public actual val mk_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/mk_flag.svg\")") as String, fileName = "mk_flag.svg")

    public actual val eye_on_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/eye_on_fill_icon.svg\")") as String, fileName =
        "eye_on_fill_icon.svg")

    public actual val help_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/help_icon.svg\")") as String, fileName = "help_icon.svg")

    public actual val image_currency_flags: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/image_currency_flags.png\")") as String, fileName =
        "image_currency_flags.png")

    public actual val theme_phone_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/theme_phone_dark.svg\")") as String, fileName =
        "theme_phone_dark.svg")

    public actual val ic_bg_circle: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_bg_circle.svg\")") as String, fileName = "ic_bg_circle.svg")

    public actual val visa_prepaid_light: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/visa_prepaid_light.png\")") as String, fileName =
        "visa_prepaid_light.png")

    public actual val added_to_gpay_image_bg: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_bg.png\")") as String, fileName =
        "added_to_gpay_image_bg.png")

    public actual val check_menu_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/check_menu_dark.png\")") as String, fileName = "check_menu_dark.png")

    public actual val attention_circle_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/attention_circle_image.png\")") as String, fileName =
        "attention_circle_image.png")

    public actual val send_receive_gift_card_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/send_receive_gift_card_icon.png\")") as String, fileName =
        "send_receive_gift_card_icon.png")

    public actual val star_icon_yellow: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/star_icon_yellow.png\")") as String, fileName =
        "star_icon_yellow.png")

    public actual val support_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/support_icon.svg\")") as String, fileName = "support_icon.svg")

    public actual val bank_transfer_icon_sepa: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bank_transfer_icon_sepa.png\")") as String, fileName =
        "bank_transfer_icon_sepa.png")

    public actual val get_help_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/get_help_image.png\")") as String, fileName = "get_help_image.png")

    public actual val tr_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/tr_flag.svg\")") as String, fileName = "tr_flag.svg")

    public actual val finger_animation_27: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_27.png\")") as String, fileName =
        "finger_animation_27.png")

    public actual val unfreeze_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/unfreeze_fill_icon.svg\")") as String, fileName =
        "unfreeze_fill_icon.svg")

    public actual val clock_alert_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/clock_alert_icon.svg\")") as String, fileName =
        "clock_alert_icon.svg")

    public actual val add_money_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_money_fill_icon.svg\")") as String, fileName =
        "add_money_fill_icon.svg")

    public actual val crop_card_frame_img: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/crop_card_frame_img.png\")") as String, fileName =
        "crop_card_frame_img.png")

    public actual val location_pin_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/location_pin_fill_icon.svg\")") as String, fileName =
        "location_pin_fill_icon.svg")

    public actual val adding_card_en_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_en_dark.png\")") as String, fileName =
        "adding_card_en_dark.png")

    public actual val plastic_GiftCard_details: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/plastic_GiftCard_details.png\")") as String, fileName =
        "plastic_GiftCard_details.png")

    public actual val ic_food_dish: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_food_dish.svg\")") as String, fileName = "ic_food_dish.svg")

    public actual val add_to_gpay_image_dark_it: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_dark_it.png\")") as String, fileName =
        "add_to_gpay_image_dark_it.png")

    public actual val payment_method: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/payment_method.png\")") as String, fileName = "payment_method.png")

    public actual val funds_disbursement_mastercard_logo: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/funds_disbursement_mastercard_logo.png\")") as String, fileName =
        "funds_disbursement_mastercard_logo.png")

    public actual val heart_favorite: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/heart_favorite.svg\")") as String, fileName = "heart_favorite.svg")

    public actual val navigation_info: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/navigation_info.svg\")") as String, fileName = "navigation_info.svg")

    public actual val back_arrow_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/back_arrow_icon.svg\")") as String, fileName = "back_arrow_icon.svg")

    public actual val virtual_card_frozen_overlay_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/virtual_card_frozen_overlay_image.png\")") as String, fileName =
        "virtual_card_frozen_overlay_image.png")

    public actual val icard_transaction_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/icard_transaction_icon.png\")") as String, fileName =
        "icard_transaction_icon.png")

    public actual val right_arrow: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/right_arrow.svg\")") as String, fileName = "right_arrow.svg")

    public actual val gallery_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/gallery_fill_icon.svg\")") as String, fileName =
        "gallery_fill_icon.svg")

    public actual val finger_animation_11: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_11.png\")") as String, fileName =
        "finger_animation_11.png")

    public actual val location_tab_details_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/location_tab_details_icon.png\")") as String, fileName =
        "location_tab_details_icon.png")

    public actual val xk_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/xk_flag.svg\")") as String, fileName = "xk_flag.svg")

    public actual val visa_infinite_logo: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/visa_infinite_logo.png\")") as String, fileName =
        "visa_infinite_logo.png")

    public actual val ua_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ua_flag.svg\")") as String, fileName = "ua_flag.svg")

    public actual val visa_electron_logo_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/visa_electron_logo_icon.png\")") as String, fileName =
        "visa_electron_logo_icon.png")

    public actual val activate_key_fob_placeholder: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/activate_key_fob_placeholder.png\")") as String, fileName =
        "activate_key_fob_placeholder.png")

    public actual val donations_side_menu_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/donations_side_menu_icon.png\")") as String, fileName =
        "donations_side_menu_icon.png")

    public actual val transfer_alert_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/transfer_alert_icon.png\")") as String, fileName =
        "transfer_alert_icon.png")

    public actual val finger_animation_2: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_2.png\")") as String, fileName =
        "finger_animation_2.png")

    public actual val image_bank_funding: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/image_bank_funding.png\")") as String, fileName =
        "image_bank_funding.png")

    public actual val ic_ro_circle: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_ro_circle.svg\")") as String, fileName = "ic_ro_circle.svg")

    public actual val web_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/web_fill_icon.svg\")") as String, fileName = "web_fill_icon.svg")

    public actual val nav_find: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/nav_find.svg\")") as String, fileName = "nav_find.svg")

    public actual val red_plus_fab_background: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/red_plus_fab_background.png\")") as String, fileName =
        "red_plus_fab_background.png")

    public actual val clock_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/clock_fill_icon.svg\")") as String, fileName = "clock_fill_icon.svg")

    public actual val ic_en_circle: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_en_circle.svg\")") as String, fileName = "ic_en_circle.svg")

    public actual val added_to_gpay_image_dark_de: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_dark_de.png\")") as String, fileName =
        "added_to_gpay_image_dark_de.png")

    public actual val planet_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/planet_fill_icon.svg\")") as String, fileName =
        "planet_fill_icon.svg")

    public actual val contactless_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/contactless_icon.svg\")") as String, fileName =
        "contactless_icon.svg")

    public actual val card_fee_monthly_img: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/card_fee_monthly_img.png\")") as String, fileName =
        "card_fee_monthly_img.png")

    public actual val reset_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/reset_fill_icon.svg\")") as String, fileName = "reset_fill_icon.svg")

    public actual val vpay_logo_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/vpay_logo_icon.png\")") as String, fileName = "vpay_logo_icon.png")

    public actual val star_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/star_icon.svg\")") as String, fileName = "star_icon.svg")

    public actual val faster_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/faster_icon.svg\")") as String, fileName = "faster_icon.svg")

    public actual val adding_card_de_light: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_de_light.png\")") as String, fileName =
        "adding_card_de_light.png")

    public actual val de_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/de_flag.svg\")") as String, fileName = "de_flag.svg")

    public actual val email_outline_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/email_outline_icon.png\")") as String, fileName =
        "email_outline_icon.png")

    public actual val limits_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/limits_fill_icon.svg\")") as String, fileName =
        "limits_fill_icon.svg")

    public actual val theme_phone_light: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/theme_phone_light.svg\")") as String, fileName =
        "theme_phone_light.svg")

    public actual val chf_circle_flag_small: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/chf_circle_flag_small.png\")") as String, fileName =
        "chf_circle_flag_small.png")

    public actual val gpay_logo_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/gpay_logo_icon.png\")") as String, fileName = "gpay_logo_icon.png")

    public actual val star_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/star_fill_icon.svg\")") as String, fileName = "star_fill_icon.svg")

    public actual val instagram: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/instagram.svg\")") as String, fileName = "instagram.svg")

    public actual val welcome_2: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/welcome_2.png\")") as String, fileName = "welcome_2.png")

    public actual val outgoing_bank_transfer_transaction_icon: ImageResource = ImageResource(fileUrl
        = js("require(\"./images/outgoing_bank_transfer_transaction_icon.png\")") as String,
        fileName = "outgoing_bank_transfer_transaction_icon.png")

    public actual val password_error_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/password_error_icon.svg\")") as String, fileName =
        "password_error_icon.svg")

    public actual val remove_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/remove_icon.svg\")") as String, fileName = "remove_icon.svg")

    public actual val incomming_bank_transfer_transaction_icon: ImageResource =
        ImageResource(fileUrl =
        js("require(\"./images/incomming_bank_transfer_transaction_icon.png\")") as String, fileName
        = "incomming_bank_transfer_transaction_icon.png")

    public actual val added_to_gpay_image_dark_es: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_dark_es.png\")") as String, fileName =
        "added_to_gpay_image_dark_es.png")

    public actual val added_to_gpay_image_dark_ro: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_dark_ro.png\")") as String, fileName =
        "added_to_gpay_image_dark_ro.png")

    public actual val navigation_switch_user: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/navigation_switch_user.svg\")") as String, fileName =
        "navigation_switch_user.svg")

    public actual val physical_card_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/physical_card_fill_icon.svg\")") as String, fileName =
        "physical_card_fill_icon.svg")

    public actual val lu_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/lu_flag.svg\")") as String, fileName = "lu_flag.svg")

    public actual val lt_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/lt_flag.svg\")") as String, fileName = "lt_flag.svg")

    public actual val contact_phone: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/contact_phone.svg\")") as String, fileName = "contact_phone.svg")

    public actual val add_to_gpay_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image.png\")") as String, fileName =
        "add_to_gpay_image.png")

    public actual val limited_access_offline_warning_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/limited_access_offline_warning_image.png\")") as String, fileName =
        "limited_access_offline_warning_image.png")

    public actual val ic_chat_with_us: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_chat_with_us.svg\")") as String, fileName = "ic_chat_with_us.svg")

    public actual val nav_reservations: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/nav_reservations.svg\")") as String, fileName =
        "nav_reservations.svg")

    public actual val eye_off_outline_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/eye_off_outline_icon.svg\")") as String, fileName =
        "eye_off_outline_icon.svg")

    public actual val visa_electron_circle_logo: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/visa_electron_circle_logo.png\")") as String, fileName =
        "visa_electron_circle_logo.png")

    public actual val add_bag_gluten_free: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_bag_gluten_free.svg\")") as String, fileName =
        "add_bag_gluten_free.svg")

    public actual val fr_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/fr_flag.svg\")") as String, fileName = "fr_flag.svg")

    public actual val finger_animation_19: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_19.png\")") as String, fileName =
        "finger_animation_19.png")

    public actual val location_tab_allergens_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/location_tab_allergens_icon.svg\")") as String, fileName =
        "location_tab_allergens_icon.svg")

    public actual val qr_code_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/qr_code_icon.svg\")") as String, fileName = "qr_code_icon.svg")

    public actual val illustration_side_menu_cashback_discounts: ImageResource =
        ImageResource(fileUrl =
        js("require(\"./images/illustration_side_menu_cashback_discounts.png\")") as String,
        fileName = "illustration_side_menu_cashback_discounts.png")

    public actual val finger_animation_6: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_6.png\")") as String, fileName =
        "finger_animation_6.png")

    public actual val ic_dropdown_white: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_dropdown_white.svg\")") as String, fileName =
        "ic_dropdown_white.svg")

    public actual val cashback: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/cashback.png\")") as String, fileName = "cashback.png")

    public actual val alert_white_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/alert_white_fill_icon.svg\")") as String, fileName =
        "alert_white_fill_icon.svg")

    public actual val bag_menu_info: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bag_menu_info.svg\")") as String, fileName = "bag_menu_info.svg")

    public actual val nfc_wearable_logo: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/nfc_wearable_logo.png\")") as String, fileName =
        "nfc_wearable_logo.png")

    public actual val contactless_white: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/contactless_white.png\")") as String, fileName =
        "contactless_white.png")

    public actual val ie_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ie_flag.svg\")") as String, fileName = "ie_flag.svg")

    public actual val added_to_icard_pay_image_fr: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_fr.png\")") as String, fileName =
        "added_to_icard_pay_image_fr.png")

    public actual val pln_circle_flag_small: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/pln_circle_flag_small.png\")") as String, fileName =
        "pln_circle_flag_small.png")

    public actual val bank_transfer_icon_bisera: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bank_transfer_icon_bisera.png\")") as String, fileName =
        "bank_transfer_icon_bisera.png")

    public actual val star_6: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/star_6.svg\")") as String, fileName = "star_6.svg")

    public actual val bank_transfer_status_declined_big: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bank_transfer_status_declined_big.png\")") as String, fileName =
        "bank_transfer_status_declined_big.png")

    public actual val finger_animation_15: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_15.png\")") as String, fileName =
        "finger_animation_15.png")

    public actual val added_to_icard_pay_image_el: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_el.png\")") as String, fileName =
        "added_to_icard_pay_image_el.png")

    public actual val benefit_bank_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/benefit_bank_fill_icon.svg\")") as String, fileName =
        "benefit_bank_fill_icon.svg")

    public actual val card_status_processing: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/card_status_processing.png\")") as String, fileName =
        "card_status_processing.png")

    public actual val vignette_transaction_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/vignette_transaction_icon.png\")") as String, fileName =
        "vignette_transaction_icon.png")

    public actual val no_permission_contacts_img: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/no_permission_contacts_img.png\")") as String, fileName =
        "no_permission_contacts_img.png")

    public actual val adding_card_it_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_it_dark.png\")") as String, fileName =
        "adding_card_it_dark.png")

    public actual val plus_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/plus_fill_icon.svg\")") as String, fileName = "plus_fill_icon.svg")

    public actual val finger_animation_23: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_23.png\")") as String, fileName =
        "finger_animation_23.png")

    public actual val nfc_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/nfc_fill_icon.svg\")") as String, fileName = "nfc_fill_icon.svg")

    public actual val checkbox_not_clicked: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/checkbox_not_clicked.svg\")") as String, fileName =
        "checkbox_not_clicked.svg")

    public actual val add_to_icard_pay_image_bg: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_icard_pay_image_bg.png\")") as String, fileName =
        "add_to_icard_pay_image_bg.png")

    public actual val ch_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ch_flag.svg\")") as String, fileName = "ch_flag.svg")

    public actual val bank_transfer_status_on_hold: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bank_transfer_status_on_hold.png\")") as String, fileName =
        "bank_transfer_status_on_hold.png")

    public actual val renew_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/renew_fill_icon.svg\")") as String, fileName = "renew_fill_icon.svg")

    public actual val add_location_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_location_icon.png\")") as String, fileName =
        "add_location_icon.png")

    public actual val at_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/at_flag.svg\")") as String, fileName = "at_flag.svg")

    public actual val alert_red_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/alert_red_fill_icon.svg\")") as String, fileName =
        "alert_red_fill_icon.svg")

    public actual val ron_circle_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ron_circle_flag.png\")") as String, fileName = "ron_circle_flag.png")

    public actual val change_design_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/change_design_fill_icon.svg\")") as String, fileName =
        "change_design_fill_icon.svg")

    public actual val rating_star_gray: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/rating_star_gray.png\")") as String, fileName =
        "rating_star_gray.png")

    public actual val illustration_empty_state_cards: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/illustration_empty_state_cards.png\")") as String, fileName =
        "illustration_empty_state_cards.png")

    public actual val camera_1: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/camera_1.svg\")") as String, fileName = "camera_1.svg")

    public actual val add_bag_clock: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_bag_clock.svg\")") as String, fileName = "add_bag_clock.svg")

    public actual val status_on_way: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/status_on_way.png\")") as String, fileName = "status_on_way.png")

    public actual val banner_add_to_g_pay: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/banner_add_to_g_pay.png\")") as String, fileName =
        "banner_add_to_g_pay.png")

    public actual val exchange_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/exchange_icon.svg\")") as String, fileName = "exchange_icon.svg")

    public actual val online_purchase_transaction_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/online_purchase_transaction_icon.png\")") as String, fileName =
        "online_purchase_transaction_icon.png")

    public actual val finger_animation_17: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_17.png\")") as String, fileName =
        "finger_animation_17.png")

    public actual val ic_chevron_right_blue: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_chevron_right_blue.svg\")") as String, fileName =
        "ic_chevron_right_blue.svg")

    public actual val added_to_icard_pay_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image.png\")") as String, fileName =
        "added_to_icard_pay_image.png")

    public actual val buy_bus_ticket_event_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/buy_bus_ticket_event_icon.png\")") as String, fileName =
        "buy_bus_ticket_event_icon.png")

    public actual val finger_animation_8: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_8.png\")") as String, fileName =
        "finger_animation_8.png")

    public actual val ic_close_white: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_close_white.svg\")") as String, fileName = "ic_close_white.svg")

    public actual val sm_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/sm_flag.svg\")") as String, fileName = "sm_flag.svg")

    public actual val gbp_circle_flag_small: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/gbp_circle_flag_small.png\")") as String, fileName =
        "gbp_circle_flag_small.png")

    public actual val finger_animation_4: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_4.png\")") as String, fileName =
        "finger_animation_4.png")

    public actual val confirm_email_bell_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/confirm_email_bell_icon.svg\")") as String, fileName =
        "confirm_email_bell_icon.svg")

    public actual val image_response_code_success: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/image_response_code_success.png\")") as String, fileName =
        "image_response_code_success.png")

    public actual val linked_card_visa_electron_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/linked_card_visa_electron_icon.png\")") as String, fileName =
        "linked_card_visa_electron_icon.png")

    public actual val wallet_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/wallet_fill_icon.svg\")") as String, fileName =
        "wallet_fill_icon.svg")

    public actual val add_to_icard_pay_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_icard_pay_image.png\")") as String, fileName =
        "add_to_icard_pay_image.png")

    public actual val added_to_gpay_image_dark_it: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_dark_it.png\")") as String, fileName =
        "added_to_gpay_image_dark_it.png")

    public actual val visa_logo: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/visa_logo.png\")") as String, fileName = "visa_logo.png")

    public actual val id_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/id_fill_icon.svg\")") as String, fileName = "id_fill_icon.svg")

    public actual val ic_file: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_file.svg\")") as String, fileName = "ic_file.svg")

    public actual val added_to_gpay_image_fr: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_fr.png\")") as String, fileName =
        "added_to_gpay_image_fr.png")

    public actual val gift_card_menu_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/gift_card_menu_icon.png\")") as String, fileName =
        "gift_card_menu_icon.png")

    public actual val added_to_gpay_image_el: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_el.png\")") as String, fileName =
        "added_to_gpay_image_el.png")

    public actual val virtual_card_design_067: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/virtual_card_design_067.png\")") as String, fileName =
        "virtual_card_design_067.png")

    public actual val ic_icon_nfc: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_icon_nfc.svg\")") as String, fileName = "ic_icon_nfc.svg")

    public actual val button_customize: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/button_customize.png\")") as String, fileName =
        "button_customize.png")

    public actual val menu_menu_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/menu_menu_image.png\")") as String, fileName = "menu_menu_image.png")

    public actual val rope_outline_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/rope_outline_icon.svg\")") as String, fileName =
        "rope_outline_icon.svg")

    public actual val activate_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/activate_fill_icon.svg\")") as String, fileName =
        "activate_fill_icon.svg")

    public actual val gift_card_logo: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/gift_card_logo.png\")") as String, fileName = "gift_card_logo.png")

    public actual val card_fee_annually_img: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/card_fee_annually_img.png\")") as String, fileName =
        "card_fee_annually_img.png")

    public actual val maestro_circle_logo: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/maestro_circle_logo.png\")") as String, fileName =
        "maestro_circle_logo.png")

    public actual val finger_animation_21: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_21.png\")") as String, fileName =
        "finger_animation_21.png")

    public actual val be_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/be_flag.svg\")") as String, fileName = "be_flag.svg")

    public actual val visa_logo_white: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/visa_logo_white.png\")") as String, fileName = "visa_logo_white.png")

    public actual val ic_disabled_wi_fi_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_disabled_wi_fi_icon.svg\")") as String, fileName =
        "ic_disabled_wi_fi_icon.svg")

    public actual val contacts_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/contacts_icon.png\")") as String, fileName = "contacts_icon.png")

    public actual val add_first_bag_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_first_bag_icon.png\")") as String, fileName =
        "add_first_bag_icon.png")

    public actual val watch_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/watch_icon.png\")") as String, fileName = "watch_icon.png")

    public actual val more_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/more_icon.svg\")") as String, fileName = "more_icon.svg")

    public actual val ic_icon_nfc_white: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_icon_nfc_white.svg\")") as String, fileName =
        "ic_icon_nfc_white.svg")

    public actual val contactless_state_4: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/contactless_state_4.png\")") as String, fileName =
        "contactless_state_4.png")

    public actual val gift_card_the_perfect_gift_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/gift_card_the_perfect_gift_dark.svg\")") as String, fileName =
        "gift_card_the_perfect_gift_dark.svg")

    public actual val img_placeholder: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/img_placeholder.svg\")") as String, fileName = "img_placeholder.svg")

    public actual val success_activate_card_dialog_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/success_activate_card_dialog_image.png\")") as String, fileName =
        "success_activate_card_dialog_image.png")

    public actual val bgn_circle_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bgn_circle_flag.png\")") as String, fileName = "bgn_circle_flag.png")

    public actual val cashback_event_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/cashback_event_icon.png\")") as String, fileName =
        "cashback_event_icon.png")

    public actual val bet_365_card: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bet_365_card.png\")") as String, fileName = "bet_365_card.png")

    public actual val add_to_icard_pay_image_nl: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_icard_pay_image_nl.png\")") as String, fileName =
        "add_to_icard_pay_image_nl.png")

    public actual val adding_card_bg_light: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_bg_light.png\")") as String, fileName =
        "adding_card_bg_light.png")

    public actual val concierge_outline_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/concierge_outline_icon.svg\")") as String, fileName =
        "concierge_outline_icon.svg")

    public actual val visa_circle_logo: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/visa_circle_logo.png\")") as String, fileName =
        "visa_circle_logo.png")

    public actual val pos_purchase_transaction_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/pos_purchase_transaction_icon.png\")") as String, fileName =
        "pos_purchase_transaction_icon.png")

    public actual val pending_circle: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/pending_circle.svg\")") as String, fileName = "pending_circle.svg")

    public actual val youtube_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/youtube_icon.png\")") as String, fileName = "youtube_icon.png")

    public actual val new_label_gold: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/new_label_gold.png\")") as String, fileName = "new_label_gold.png")

    public actual val hint_3ds_push_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/hint_3ds_push_image.png\")") as String, fileName =
        "hint_3ds_push_image.png")

    public actual val home_view_map: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/home_view_map.svg\")") as String, fileName = "home_view_map.svg")

    public actual val ru_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ru_flag.svg\")") as String, fileName = "ru_flag.svg")

    public actual val ic_fr_circle: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_fr_circle.svg\")") as String, fileName = "ic_fr_circle.svg")

    public actual val discounts_outline_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/discounts_outline_icon.svg\")") as String, fileName =
        "discounts_outline_icon.svg")

    public actual val ic_favorite_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_favorite_icon.svg\")") as String, fileName =
        "ic_favorite_icon.svg")

    public actual val meter_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/meter_fill_icon.svg\")") as String, fileName = "meter_fill_icon.svg")

    public actual val padlock_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/padlock_fill_icon.svg\")") as String, fileName =
        "padlock_fill_icon.svg")

    public actual val select_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/select_icon.svg\")") as String, fileName = "select_icon.svg")

    public actual val dk_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/dk_flag.svg\")") as String, fileName = "dk_flag.svg")

    public actual val login_backspace_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/login_backspace_icon.svg\")") as String, fileName =
        "login_backspace_icon.svg")

    public actual val ic_selection_arrow: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_selection_arrow.svg\")") as String, fileName =
        "ic_selection_arrow.svg")

    public actual val bag_menu_pencil: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bag_menu_pencil.svg\")") as String, fileName = "bag_menu_pencil.svg")

    public actual val linked_card_mc_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/linked_card_mc_icon.png\")") as String, fileName =
        "linked_card_mc_icon.png")

    public actual val contactless_state_1: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/contactless_state_1.png\")") as String, fileName =
        "contactless_state_1.png")

    public actual val icard_welcome_card_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/icard_welcome_card_image.png\")") as String, fileName =
        "icard_welcome_card_image.png")

    public actual val home_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/home_fill_icon.svg\")") as String, fileName = "home_fill_icon.svg")

    public actual val circle_alert: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/circle_alert.png\")") as String, fileName = "circle_alert.png")

    public actual val added_to_gpay_image_dark_el: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_dark_el.png\")") as String, fileName =
        "added_to_gpay_image_dark_el.png")

    public actual val image_response_code_yellow: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/image_response_code_yellow.png\")") as String, fileName =
        "image_response_code_yellow.png")

    public actual val gift_card_the_perfect_gift_white: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/gift_card_the_perfect_gift_white.svg\")") as String, fileName =
        "gift_card_the_perfect_gift_white.svg")

    public actual val added_to_gpay_image_dark_fr: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_dark_fr.png\")") as String, fileName =
        "added_to_gpay_image_dark_fr.png")

    public actual val open_camera_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/open_camera_icon.svg\")") as String, fileName =
        "open_camera_icon.svg")

    public actual val card_status_approved: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/card_status_approved.png\")") as String, fileName =
        "card_status_approved.png")

    public actual val added_to_gpay_image_it: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_it.png\")") as String, fileName =
        "added_to_gpay_image_it.png")

    public actual val welcome_5: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/welcome_5.png\")") as String, fileName = "welcome_5.png")

    public actual val adding_card_nl_light: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_nl_light.png\")") as String, fileName =
        "adding_card_nl_light.png")

    public actual val success_green_check_with_circle_big: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/success_green_check_with_circle_big.png\")") as String, fileName =
        "success_green_check_with_circle_big.png")

    public actual val pencil_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/pencil_icon.svg\")") as String, fileName = "pencil_icon.svg")

    public actual val mastercard_logo: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/mastercard_logo.png\")") as String, fileName = "mastercard_logo.png")

    public actual val mol_edit_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/mol_edit_icon.svg\")") as String, fileName = "mol_edit_icon.svg")

    public actual val camera_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/camera_icon.svg\")") as String, fileName = "camera_icon.svg")

    public actual val sepa_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/sepa_fill_icon.svg\")") as String, fileName = "sepa_fill_icon.svg")

    public actual val cash_outline_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/cash_outline_icon.svg\")") as String, fileName =
        "cash_outline_icon.svg")

    public actual val image_premium_card: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/image_premium_card.png\")") as String, fileName =
        "image_premium_card.png")

    public actual val hr_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/hr_flag.svg\")") as String, fileName = "hr_flag.svg")

    public actual val loyalty_card_menu_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/loyalty_card_menu_icon.png\")") as String, fileName =
        "loyalty_card_menu_icon.png")

    public actual val add_to_gpay_image_dark_bg: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_dark_bg.png\")") as String, fileName =
        "add_to_gpay_image_dark_bg.png")

    public actual val adding_card_fr_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_fr_dark.png\")") as String, fileName =
        "adding_card_fr_dark.png")

    public actual val star_express_delivery: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/star_express_delivery.png\")") as String, fileName =
        "star_express_delivery.png")

    public actual val bank_transfer_icon_blink: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bank_transfer_icon_blink.png\")") as String, fileName =
        "bank_transfer_icon_blink.png")

    public actual val plastic_gift_card_design_020: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/plastic_gift_card_design_020.png\")") as String, fileName =
        "plastic_gift_card_design_020.png")

    public actual val virtual_card_design_037: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/virtual_card_design_037.png\")") as String, fileName =
        "virtual_card_design_037.png")

    public actual val added_to_icard_pay_image_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_dark.png\")") as String, fileName =
        "added_to_icard_pay_image_dark.png")

    public actual val business_preview_3: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/business_preview_3.png\")") as String, fileName =
        "business_preview_3.png")

    public actual val bank_transfer_status_processing_big: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bank_transfer_status_processing_big.png\")") as String, fileName =
        "bank_transfer_status_processing_big.png")

    public actual val added_to_icard_pay_image_dark_bg: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_dark_bg.png\")") as String, fileName =
        "added_to_icard_pay_image_dark_bg.png")

    public actual val prepaid_icard: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/prepaid_icard.png\")") as String, fileName = "prepaid_icard.png")

    public actual val giftcard_the_perfect_gift_logo_white: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/giftcard_the_perfect_gift_logo_white.png\")") as String, fileName =
        "giftcard_the_perfect_gift_logo_white.png")

    public actual val copy_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/copy_icon.svg\")") as String, fileName = "copy_icon.svg")

    public actual val finger_animation_1: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_1.png\")") as String, fileName =
        "finger_animation_1.png")

    public actual val add_to_gpay_image_nl: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_nl.png\")") as String, fileName =
        "add_to_gpay_image_nl.png")

    public actual val tap_and_pay_nfc_disabled_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/tap_and_pay_nfc_disabled_icon.png\")") as String, fileName =
        "tap_and_pay_nfc_disabled_icon.png")

    public actual val facebook_color: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/facebook_color.svg\")") as String, fileName = "facebook_color.svg")

    public actual val progress_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/progress_image.png\")") as String, fileName = "progress_image.png")

    public actual val close_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/close_icon.svg\")") as String, fileName = "close_icon.svg")

    public actual val avatar_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/avatar_fill_icon.svg\")") as String, fileName =
        "avatar_fill_icon.svg")

    public actual val check_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/check_fill_icon.svg\")") as String, fileName = "check_fill_icon.svg")

    public actual val illustration_side_menu_e_buss_ticket: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/illustration_side_menu_e_buss_ticket.png\")") as String, fileName =
        "illustration_side_menu_e_buss_ticket.png")

    public actual val added_to_icard_pay_image_de: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_de.png\")") as String, fileName =
        "added_to_icard_pay_image_de.png")

    public actual val online_payment_outlined_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/online_payment_outlined_icon.svg\")") as String, fileName =
        "online_payment_outlined_icon.svg")

    public actual val ro_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ro_flag.svg\")") as String, fileName = "ro_flag.svg")

    public actual val mc_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/mc_flag.svg\")") as String, fileName = "mc_flag.svg")

    public actual val finger_animation_12: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_12.png\")") as String, fileName =
        "finger_animation_12.png")

    public actual val info_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/info_fill_icon.svg\")") as String, fileName = "info_fill_icon.svg")

    public actual val no_results_found_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/no_results_found_image.png\")") as String, fileName =
        "no_results_found_image.png")

    public actual val ic_restaurant_menu: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_restaurant_menu.svg\")") as String, fileName =
        "ic_restaurant_menu.svg")

    public actual val loyalty_card_back_default: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/loyalty_card_back_default.png\")") as String, fileName =
        "loyalty_card_back_default.png")

    public actual val bag_menu_trash: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bag_menu_trash.svg\")") as String, fileName = "bag_menu_trash.svg")

    public actual val ic_add_money: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_add_money.svg\")") as String, fileName = "ic_add_money.svg")

    public actual val biometric_lock_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/biometric_lock_icon.svg\")") as String, fileName =
        "biometric_lock_icon.svg")

    public actual val added_to_icard_pay_image_ro: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_ro.png\")") as String, fileName =
        "added_to_icard_pay_image_ro.png")

    public actual val pending_request_bitpanda_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/pending_request_bitpanda_icon.svg\")") as String, fileName =
        "pending_request_bitpanda_icon.svg")

    public actual val added_to_icard_pay_image_es: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_es.png\")") as String, fileName =
        "added_to_icard_pay_image_es.png")

    public actual val withdraw_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/withdraw_fill_icon.svg\")") as String, fileName =
        "withdraw_fill_icon.svg")

    public actual val upload_document_outlined_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/upload_document_outlined_icon.svg\")") as String, fileName =
        "upload_document_outlined_icon.svg")

    public actual val finger_animation_24: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_24.png\")") as String, fileName =
        "finger_animation_24.png")

    public actual val bank_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bank_fill_icon.svg\")") as String, fileName = "bank_fill_icon.svg")

    public actual val es_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/es_flag.svg\")") as String, fileName = "es_flag.svg")

    public actual val discount_successfully_activate_card_img: ImageResource = ImageResource(fileUrl
        = js("require(\"./images/discount_successfully_activate_card_img.png\")") as String,
        fileName = "discount_successfully_activate_card_img.png")

    public actual val jpy_circle_flag_small: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/jpy_circle_flag_small.png\")") as String, fileName =
        "jpy_circle_flag_small.png")

    public actual val finger_animation_28: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_28.png\")") as String, fileName =
        "finger_animation_28.png")

    public actual val order_plastic_giftcard_transaction_icon: ImageResource = ImageResource(fileUrl
        = js("require(\"./images/order_plastic_giftcard_transaction_icon.png\")") as String,
        fileName = "order_plastic_giftcard_transaction_icon.png")

    public actual val map_pin_clicked: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/map_pin_clicked.svg\")") as String, fileName = "map_pin_clicked.svg")

    public actual val cashterminal_locations: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/cashterminal_locations.png\")") as String, fileName =
        "cashterminal_locations.png")

    public actual val staff_edit_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/staff_edit_icon.svg\")") as String, fileName = "staff_edit_icon.svg")

    public actual val nl_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/nl_flag.svg\")") as String, fileName = "nl_flag.svg")

    public actual val adding_card_nl_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_nl_dark.png\")") as String, fileName =
        "adding_card_nl_dark.png")

    public actual val ad_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ad_flag.svg\")") as String, fileName = "ad_flag.svg")

    public actual val add_bag_shopping_bag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_bag_shopping_bag.svg\")") as String, fileName =
        "add_bag_shopping_bag.svg")

    public actual val visa_click_to_pay_whats_new: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/visa_click_to_pay_whats_new.png\")") as String, fileName =
        "visa_click_to_pay_whats_new.png")

    public actual val cy_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/cy_flag.svg\")") as String, fileName = "cy_flag.svg")

    public actual val finger_animation_10: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_10.png\")") as String, fileName =
        "finger_animation_10.png")

    public actual val infinite_prepaid_card: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/infinite_prepaid_card.png\")") as String, fileName =
        "infinite_prepaid_card.png")

    public actual val image_online_payment: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/image_online_payment.png\")") as String, fileName =
        "image_online_payment.png")

    public actual val crop_card_plastic_gift_frame_img: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/crop_card_plastic_gift_frame_img.png\")") as String, fileName =
        "crop_card_plastic_gift_frame_img.png")

    public actual val whatsapp: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/whatsapp.svg\")") as String, fileName = "whatsapp.svg")

    public actual val added_to_gpay_image_es: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_es.png\")") as String, fileName =
        "added_to_gpay_image_es.png")

    public actual val added_to_gpay_image_ro: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_ro.png\")") as String, fileName =
        "added_to_gpay_image_ro.png")

    public actual val ic_es_circle: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_es_circle.svg\")") as String, fileName = "ic_es_circle.svg")

    public actual val finger_animation_3: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_3.png\")") as String, fileName =
        "finger_animation_3.png")

    public actual val utility_bills_transaction_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/utility_bills_transaction_icon.png\")") as String, fileName =
        "utility_bills_transaction_icon.png")

    public actual val ic_camera_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_camera_image.png\")") as String, fileName = "ic_camera_image.png")

    public actual val illustration_side_menu_premium_cards: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/illustration_side_menu_premium_cards.png\")") as String, fileName =
        "illustration_side_menu_premium_cards.png")

    public actual val merchant_tab_bags: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/merchant_tab_bags.svg\")") as String, fileName =
        "merchant_tab_bags.svg")

    public actual val adding_card_it_light: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_it_light.png\")") as String, fileName =
        "adding_card_it_light.png")

    public actual val business_preview_1: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/business_preview_1.png\")") as String, fileName =
        "business_preview_1.png")

    public actual val add_to_gpay_image_dark_nl: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_dark_nl.png\")") as String, fileName =
        "add_to_gpay_image_dark_nl.png")

    public actual val card_bottom_sheet_activity_btn: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/card_bottom_sheet_activity_btn.png\")") as String, fileName =
        "card_bottom_sheet_activity_btn.png")

    public actual val shield_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/shield_icon.svg\")") as String, fileName = "shield_icon.svg")

    public actual val phone_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/phone_fill_icon.svg\")") as String, fileName = "phone_fill_icon.svg")

    public actual val send_us_email: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/send_us_email.png\")") as String, fileName = "send_us_email.png")

    public actual val ic_chevron_left: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_chevron_left.svg\")") as String, fileName = "ic_chevron_left.svg")

    public actual val added_to_gpay_image_de: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_de.png\")") as String, fileName =
        "added_to_gpay_image_de.png")

    public actual val activate_card_arrow_white: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/activate_card_arrow_white.png\")") as String, fileName =
        "activate_card_arrow_white.png")

    public actual val profile_default_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/profile_default_image.png\")") as String, fileName =
        "profile_default_image.png")

    public actual val checkbox_not_clicked_web: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/checkbox_not_clicked_web.svg\")") as String, fileName =
        "checkbox_not_clicked_web.svg")

    public actual val it_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/it_flag.svg\")") as String, fileName = "it_flag.svg")

    public actual val cashterminal_logo: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/cashterminal_logo.png\")") as String, fileName =
        "cashterminal_logo.png")

    public actual val finger_animation_26: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_26.png\")") as String, fileName =
        "finger_animation_26.png")

    public actual val ic_airplane_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_airplane_icon.svg\")") as String, fileName =
        "ic_airplane_icon.svg")

    public actual val round_up_icon_small: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/round_up_icon_small.png\")") as String, fileName =
        "round_up_icon_small.png")

    public actual val pl_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/pl_flag.svg\")") as String, fileName = "pl_flag.svg")

    public actual val add_money_via_bank_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_money_via_bank_icon.png\")") as String, fileName =
        "add_money_via_bank_icon.png")

    public actual val ic_copy_iban: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_copy_iban.svg\")") as String, fileName = "ic_copy_iban.svg")

    public actual val avatar_image_frame: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/avatar_image_frame.png\")") as String, fileName =
        "avatar_image_frame.png")

    public actual val ic_cross_filled: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_cross_filled.svg\")") as String, fileName = "ic_cross_filled.svg")

    public actual val home_top_pick_star: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/home_top_pick_star.svg\")") as String, fileName =
        "home_top_pick_star.svg")

    public actual val tap_n_pay_black: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/tap_n_pay_black.png\")") as String, fileName = "tap_n_pay_black.png")

    public actual val phone_outline_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/phone_outline_icon.png\")") as String, fileName =
        "phone_outline_icon.png")

    public actual val eur_circle_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/eur_circle_flag.png\")") as String, fileName = "eur_circle_flag.png")

    public actual val si_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/si_flag.svg\")") as String, fileName = "si_flag.svg")

    public actual val camera_outlined_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/camera_outlined_icon.svg\")") as String, fileName =
        "camera_outlined_icon.svg")

    public actual val contactless_state_3: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/contactless_state_3.png\")") as String, fileName =
        "contactless_state_3.png")

    public actual val bin_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bin_fill_icon.svg\")") as String, fileName = "bin_fill_icon.svg")

    public actual val location_tab_menu_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/location_tab_menu_icon.svg\")") as String, fileName =
        "location_tab_menu_icon.svg")

    public actual val error_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/error_image.png\")") as String, fileName = "error_image.png")

    public actual val round_up_hint_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/round_up_hint_image.png\")") as String, fileName =
        "round_up_hint_image.png")

    public actual val ic_arrow_down: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_arrow_down.svg\")") as String, fileName = "ic_arrow_down.svg")

    public actual val freeze_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/freeze_fill_icon.svg\")") as String, fileName =
        "freeze_fill_icon.svg")

    public actual val visa_logo_new: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/visa_logo_new.svg\")") as String, fileName = "visa_logo_new.svg")

    public actual val sent_payment_transaction_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/sent_payment_transaction_icon.png\")") as String, fileName =
        "sent_payment_transaction_icon.png")

    public actual val added_to_icard_pay_image_it: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_it.png\")") as String, fileName =
        "added_to_icard_pay_image_it.png")

    public actual val apple_pay_event_logo_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/apple_pay_event_logo_icon.png\")") as String, fileName =
        "apple_pay_event_logo_icon.png")

    public actual val youtube: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/youtube.svg\")") as String, fileName = "youtube.svg")

    public actual val image_card_payment: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/image_card_payment.png\")") as String, fileName =
        "image_card_payment.png")

    public actual val redeem_funds_transaction_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/redeem_funds_transaction_icon.png\")") as String, fileName =
        "redeem_funds_transaction_icon.png")

    public actual val add_to_gpay_image_bg: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_bg.png\")") as String, fileName =
        "add_to_gpay_image_bg.png")

    public actual val transp_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/transp_flag.png\")") as String, fileName = "transp_flag.png")

    public actual val info_grey_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/info_grey_fill_icon.svg\")") as String, fileName =
        "info_grey_fill_icon.svg")

    public actual val added_to_icard_pay_image_dark_nl: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_dark_nl.png\")") as String, fileName =
        "added_to_icard_pay_image_dark_nl.png")

    public actual val sms_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/sms_icon.png\")") as String, fileName = "sms_icon.png")

    public actual val fi_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/fi_flag.svg\")") as String, fileName = "fi_flag.svg")

    public actual val location_tab_business_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/location_tab_business_icon.svg\")") as String, fileName =
        "location_tab_business_icon.svg")

    public actual val warning_outline_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/warning_outline_icon.png\")") as String, fileName =
        "warning_outline_icon.png")

    public actual val expiry_alert_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/expiry_alert_icon.png\")") as String, fileName =
        "expiry_alert_icon.png")

    public actual val illustration_side_menu_giftcard: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/illustration_side_menu_giftcard.png\")") as String, fileName =
        "illustration_side_menu_giftcard.png")

    public actual val print_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/print_icon.svg\")") as String, fileName = "print_icon.svg")

    public actual val metal_prepaid_card: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/metal_prepaid_card.png\")") as String, fileName =
        "metal_prepaid_card.png")

    public actual val rate_us_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/rate_us_image.png\")") as String, fileName = "rate_us_image.png")

    public actual val click_to_pay_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/click_to_pay_icon.png\")") as String, fileName =
        "click_to_pay_icon.png")

    public actual val success_green_arrow_with_circle: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/success_green_arrow_with_circle.svg\")") as String, fileName =
        "success_green_arrow_with_circle.svg")

    public actual val combobox_arrow_down_green: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/combobox_arrow_down_green.svg\")") as String, fileName =
        "combobox_arrow_down_green.svg")

    public actual val welcome_7: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/welcome_7.png\")") as String, fileName = "welcome_7.png")

    public actual val location_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/location_fill_icon.svg\")") as String, fileName =
        "location_fill_icon.svg")

    public actual val umbrella_outline_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/umbrella_outline_icon.svg\")") as String, fileName =
        "umbrella_outline_icon.svg")

    public actual val gift_card_design_000: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/gift_card_design_000.png\")") as String, fileName =
        "gift_card_design_000.png")

    public actual val ic_phone_settings_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_phone_settings_icon.svg\")") as String, fileName =
        "ic_phone_settings_icon.svg")

    public actual val ba_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ba_flag.svg\")") as String, fileName = "ba_flag.svg")

    public actual val gpay_event_logo_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/gpay_event_logo_icon.png\")") as String, fileName =
        "gpay_event_logo_icon.png")

    public actual val maestro_logo_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/maestro_logo_icon.png\")") as String, fileName =
        "maestro_logo_icon.png")

    public actual val nav_account: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/nav_account.svg\")") as String, fileName = "nav_account.svg")

    public actual val finger_animation_22: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_22.png\")") as String, fileName =
        "finger_animation_22.png")

    public actual val contact_mail: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/contact_mail.svg\")") as String, fileName = "contact_mail.svg")

    public actual val image_card_funding_applepay: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/image_card_funding_applepay.png\")") as String, fileName =
        "image_card_funding_applepay.png")

    public actual val virtual_card_design_068: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/virtual_card_design_068.png\")") as String, fileName =
        "virtual_card_design_068.png")

    public actual val linked_card_jcb_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/linked_card_jcb_icon.png\")") as String, fileName =
        "linked_card_jcb_icon.png")

    public actual val close_button: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/close_button.svg\")") as String, fileName = "close_button.svg")

    public actual val se_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/se_flag.svg\")") as String, fileName = "se_flag.svg")

    public actual val li_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/li_flag.svg\")") as String, fileName = "li_flag.svg")

    public actual val add_to_icard_pay_image_de: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_icard_pay_image_de.png\")") as String, fileName =
        "add_to_icard_pay_image_de.png")

    public actual val benefit_clock_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/benefit_clock_fill_icon.svg\")") as String, fileName =
        "benefit_clock_fill_icon.svg")

    public actual val ic_internet_connection_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_internet_connection_icon.svg\")") as String, fileName =
        "ic_internet_connection_icon.svg")

    public actual val check_email_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/check_email_image.png\")") as String, fileName =
        "check_email_image.png")

    public actual val adding_card_de_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_de_dark.png\")") as String, fileName =
        "adding_card_de_dark.png")

    public actual val navigation_cash_pin: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/navigation_cash_pin.svg\")") as String, fileName =
        "navigation_cash_pin.svg")

    public actual val total_to_pay: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/total_to_pay.png\")") as String, fileName = "total_to_pay.png")

    public actual val tax_payment_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/tax_payment_icon.png\")") as String, fileName =
        "tax_payment_icon.png")

    public actual val password_eye_closed: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/password_eye_closed.svg\")") as String, fileName =
        "password_eye_closed.svg")

    public actual val information_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/information_icon.svg\")") as String, fileName =
        "information_icon.svg")

    public actual val finger_animation_7: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_7.png\")") as String, fileName =
        "finger_animation_7.png")

    public actual val is_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/is_flag.svg\")") as String, fileName = "is_flag.svg")

    public actual val finger_animation_18: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_18.png\")") as String, fileName =
        "finger_animation_18.png")

    public actual val mastercard_logo_new: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/mastercard_logo_new.svg\")") as String, fileName =
        "mastercard_logo_new.svg")

    public actual val added_to_icard_pay_image_dark_fr: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_dark_fr.png\")") as String, fileName =
        "added_to_icard_pay_image_dark_fr.png")

    public actual val circle_important_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/circle_important_fill_icon.svg\")") as String, fileName =
        "circle_important_fill_icon.svg")

    public actual val add_to_icard_pay_image_ro: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_icard_pay_image_ro.png\")") as String, fileName =
        "add_to_icard_pay_image_ro.png")

    public actual val add_to_icard_pay_image_es: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_icard_pay_image_es.png\")") as String, fileName =
        "add_to_icard_pay_image_es.png")

    public actual val image_card_funding_gpay: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/image_card_funding_gpay.png\")") as String, fileName =
        "image_card_funding_gpay.png")

    public actual val added_to_icard_pay_image_dark_el: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_icard_pay_image_dark_el.png\")") as String, fileName =
        "added_to_icard_pay_image_dark_el.png")

    public actual val visa_debit_logo_white: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/visa_debit_logo_white.png\")") as String, fileName =
        "visa_debit_logo_white.png")

    public actual val bag_collect: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bag_collect.svg\")") as String, fileName = "bag_collect.svg")

    public actual val finger_animation_14: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_14.png\")") as String, fileName =
        "finger_animation_14.png")

    public actual val combobox_arrow_right_green: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/combobox_arrow_right_green.svg\")") as String, fileName =
        "combobox_arrow_right_green.svg")

    public actual val dropdown_dots: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/dropdown_dots.svg\")") as String, fileName = "dropdown_dots.svg")

    public actual val ic_folder_open: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_folder_open.svg\")") as String, fileName = "ic_folder_open.svg")

    public actual val navigation_settings: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/navigation_settings.svg\")") as String, fileName =
        "navigation_settings.svg")

    public actual val location_tab_location_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/location_tab_location_icon.svg\")") as String, fileName =
        "location_tab_location_icon.svg")

    public actual val sleek_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/sleek_icon.png\")") as String, fileName = "sleek_icon.png")

    public actual val cast_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/cast_icon.svg\")") as String, fileName = "cast_icon.svg")

    public actual val slider_thumb: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/slider_thumb.svg\")") as String, fileName = "slider_thumb.svg")

    public actual val ic_dropdown_black: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_dropdown_black.svg\")") as String, fileName =
        "ic_dropdown_black.svg")

    public actual val welcome_3: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/welcome_3.png\")") as String, fileName = "welcome_3.png")

    public actual val add_money_via_gpay_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_money_via_gpay_icon.png\")") as String, fileName =
        "add_money_via_gpay_icon.png")

    public actual val illustration_side_menu_vignettes: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/illustration_side_menu_vignettes.png\")") as String, fileName =
        "illustration_side_menu_vignettes.png")

    public actual val fees_and_limits_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/fees_and_limits_icon.svg\")") as String, fileName =
        "fees_and_limits_icon.svg")

    public actual val filter_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/filter_icon.svg\")") as String, fileName = "filter_icon.svg")

    public actual val linked_card_visa_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/linked_card_visa_icon.png\")") as String, fileName =
        "linked_card_visa_icon.png")

    public actual val ic_chevron_right: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_chevron_right.svg\")") as String, fileName =
        "ic_chevron_right.svg")

    public actual val add_to_gpay_image_dark_fr: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_dark_fr.png\")") as String, fileName =
        "add_to_gpay_image_dark_fr.png")

    public actual val verify_identity_outline_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/verify_identity_outline_icon.svg\")") as String, fileName =
        "verify_identity_outline_icon.svg")

    public actual val add_to_gpay_image_dark_el: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_dark_el.png\")") as String, fileName =
        "add_to_gpay_image_dark_el.png")

    public actual val navigation_back: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/navigation_back.svg\")") as String, fileName = "navigation_back.svg")

    public actual val navigation_close: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/navigation_close.svg\")") as String, fileName =
        "navigation_close.svg")

    public actual val czk_circle_flag_small: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/czk_circle_flag_small.png\")") as String, fileName =
        "czk_circle_flag_small.png")

    public actual val default_pin: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/default_pin.png\")") as String, fileName = "default_pin.png")

    public actual val ic_nl_circle: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_nl_circle.svg\")") as String, fileName = "ic_nl_circle.svg")

    public actual val virtual_card_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/virtual_card_fill_icon.svg\")") as String, fileName =
        "virtual_card_fill_icon.svg")

    public actual val scan_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/scan_fill_icon.svg\")") as String, fileName = "scan_fill_icon.svg")

    public actual val added_to_gpay_image_dark_bg: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_dark_bg.png\")") as String, fileName =
        "added_to_gpay_image_dark_bg.png")

    public actual val bg_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bg_flag.svg\")") as String, fileName = "bg_flag.svg")

    public actual val navigation_chat: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/navigation_chat.svg\")") as String, fileName = "navigation_chat.svg")

    public actual val cirlce_info_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/cirlce_info_fill_icon.svg\")") as String, fileName =
        "cirlce_info_fill_icon.svg")

    public actual val qr_transaction_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/qr_transaction_icon.png\")") as String, fileName =
        "qr_transaction_icon.png")

    public actual val warning_icon_with_triangle: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/warning_icon_with_triangle.png\")") as String, fileName =
        "warning_icon_with_triangle.png")

    public actual val login_fingerprint_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/login_fingerprint_icon.png\")") as String, fileName =
        "login_fingerprint_icon.png")

    public actual val bank_transfer_icon_swift: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bank_transfer_icon_swift.png\")") as String, fileName =
        "bank_transfer_icon_swift.png")

    public actual val illustration_side_menu_insurances: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/illustration_side_menu_insurances.png\")") as String, fileName =
        "illustration_side_menu_insurances.png")

    public actual val web_language_chevron: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/web_language_chevron.svg\")") as String, fileName =
        "web_language_chevron.svg")

    public actual val add_to_gpay_image_el: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_el.png\")") as String, fileName =
        "add_to_gpay_image_el.png")

    public actual val checkbox_clicked: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/checkbox_clicked.svg\")") as String, fileName =
        "checkbox_clicked.svg")

    public actual val navigation_authorize: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/navigation_authorize.svg\")") as String, fileName =
        "navigation_authorize.svg")

    public actual val add_to_gpay_image_fr: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_gpay_image_fr.png\")") as String, fileName =
        "add_to_gpay_image_fr.png")

    public actual val home_view_grid: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/home_view_grid.svg\")") as String, fileName = "home_view_grid.svg")

    public actual val visa_infinite_gold_logo: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/visa_infinite_gold_logo.png\")") as String, fileName =
        "visa_infinite_gold_logo.png")

    public actual val illustration_side_menu_utility_bills: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/illustration_side_menu_utility_bills.png\")") as String, fileName =
        "illustration_side_menu_utility_bills.png")

    public actual val easy_to_use_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/easy_to_use_icon.svg\")") as String, fileName =
        "easy_to_use_icon.svg")

    public actual val card_top_up_transaction_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/card_top_up_transaction_icon.png\")") as String, fileName =
        "card_top_up_transaction_icon.png")

    public actual val by_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/by_flag.svg\")") as String, fileName = "by_flag.svg")

    public actual val add_to_icard_pay_image_it: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/add_to_icard_pay_image_it.png\")") as String, fileName =
        "add_to_icard_pay_image_it.png")

    public actual val exclamation_info_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/exclamation_info_icon.svg\")") as String, fileName =
        "exclamation_info_icon.svg")

    public actual val ic_check_filled_green: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_check_filled_green.svg\")") as String, fileName =
        "ic_check_filled_green.svg")

    public actual val merchant_tab_locations: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/merchant_tab_locations.svg\")") as String, fileName =
        "merchant_tab_locations.svg")

    public actual val navigation_support: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/navigation_support.svg\")") as String, fileName =
        "navigation_support.svg")

    public actual val welcome_1: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/welcome_1.png\")") as String, fileName = "welcome_1.png")

    public actual val medical_shield_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/medical_shield_fill_icon.svg\")") as String, fileName =
        "medical_shield_fill_icon.svg")

    public actual val gb_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/gb_flag.svg\")") as String, fileName = "gb_flag.svg")

    public actual val ic_arrow_up: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_arrow_up.svg\")") as String, fileName = "ic_arrow_up.svg")

    public actual val benefit_debit_card_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/benefit_debit_card_fill_icon.svg\")") as String, fileName =
        "benefit_debit_card_fill_icon.svg")

    public actual val lock_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/lock_fill_icon.svg\")") as String, fileName = "lock_fill_icon.svg")

    public actual val code_input_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/code_input_fill_icon.svg\")") as String, fileName =
        "code_input_fill_icon.svg")

    public actual val ic_check_filled_blue: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_check_filled_blue.svg\")") as String, fileName =
        "ic_check_filled_blue.svg")

    public actual val top_up_transaction_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/top_up_transaction_icon.png\")") as String, fileName =
        "top_up_transaction_icon.png")

    public actual val non_eaa_check: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/non_eaa_check.png\")") as String, fileName = "non_eaa_check.png")

    public actual val qr_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/qr_fill_icon.svg\")") as String, fileName = "qr_fill_icon.svg")

    public actual val trasnfer_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/trasnfer_icon.svg\")") as String, fileName = "trasnfer_icon.svg")

    public actual val plane_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/plane_fill_icon.svg\")") as String, fileName = "plane_fill_icon.svg")

    public actual val fees_service_fee: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/fees_service_fee.png\")") as String, fileName =
        "fees_service_fee.png")

    public actual val hrk_circle_flag_small: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/hrk_circle_flag_small.png\")") as String, fileName =
        "hrk_circle_flag_small.png")

    public actual val added_to_gpay_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image.png\")") as String, fileName =
        "added_to_gpay_image.png")

    public actual val eur_circle_flag_small: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/eur_circle_flag_small.png\")") as String, fileName =
        "eur_circle_flag_small.png")

    public actual val pln_circle_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/pln_circle_flag.png\")") as String, fileName = "pln_circle_flag.png")

    public actual val order_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/order_fill_icon.svg\")") as String, fileName = "order_fill_icon.svg")

    public actual val jcb_logo_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/jcb_logo_icon.png\")") as String, fileName = "jcb_logo_icon.png")

    public actual val hu_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/hu_flag.svg\")") as String, fileName = "hu_flag.svg")

    public actual val contacts_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/contacts_fill_icon.svg\")") as String, fileName =
        "contacts_fill_icon.svg")

    public actual val cashterminal_header: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/cashterminal_header.png\")") as String, fileName =
        "cashterminal_header.png")

    public actual val adding_card_el_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_el_dark.png\")") as String, fileName =
        "adding_card_el_dark.png")

    public actual val linked_card_vpay_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/linked_card_vpay_icon.png\")") as String, fileName =
        "linked_card_vpay_icon.png")

    public actual val va_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/va_flag.svg\")") as String, fileName = "va_flag.svg")

    public actual val transfer_type_placeholder_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/transfer_type_placeholder_icon.png\")") as String, fileName =
        "transfer_type_placeholder_icon.png")

    public actual val camera_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/camera_fill_icon.svg\")") as String, fileName =
        "camera_fill_icon.svg")

    public actual val pt_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/pt_flag.svg\")") as String, fileName = "pt_flag.svg")

    public actual val me_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/me_flag.svg\")") as String, fileName = "me_flag.svg")

    public actual val contactless_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/contactless_fill_icon.svg\")") as String, fileName =
        "contactless_fill_icon.svg")

    public actual val md_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/md_flag.svg\")") as String, fileName = "md_flag.svg")

    public actual val choose_consent_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/choose_consent_image.png\")") as String, fileName =
        "choose_consent_image.png")

    public actual val barcode_frame: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/barcode_frame.png\")") as String, fileName = "barcode_frame.png")

    public actual val heart_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/heart_fill_icon.svg\")") as String, fileName = "heart_fill_icon.svg")

    public actual val transfers_fill_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/transfers_fill_icon.svg\")") as String, fileName =
        "transfers_fill_icon.svg")

    public actual val navigation_filter: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/navigation_filter.svg\")") as String, fileName =
        "navigation_filter.svg")

    public actual val finger_animation_20: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_20.png\")") as String, fileName =
        "finger_animation_20.png")

    public actual val mobile_number_tab_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/mobile_number_tab_icon.svg\")") as String, fileName =
        "mobile_number_tab_icon.svg")

    public actual val added_to_gpay_image_dark_nl: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/added_to_gpay_image_dark_nl.png\")") as String, fileName =
        "added_to_gpay_image_dark_nl.png")

    public actual val blocked_illustration: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/blocked_illustration.png\")") as String, fileName =
        "blocked_illustration.png")

    public actual val adding_card_en_light: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_en_light.png\")") as String, fileName =
        "adding_card_en_light.png")

    public actual val visa_debit_logo_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/visa_debit_logo_dark.png\")") as String, fileName =
        "visa_debit_logo_dark.png")

    public actual val finger_animation_9: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_9.png\")") as String, fileName =
        "finger_animation_9.png")

    public actual val adding_card_es_dark: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/adding_card_es_dark.png\")") as String, fileName =
        "adding_card_es_dark.png")

    public actual val bag_age_restricted_18: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bag_age_restricted_18.svg\")") as String, fileName =
        "bag_age_restricted_18.svg")

    public actual val finger_animation_16: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_16.png\")") as String, fileName =
        "finger_animation_16.png")

    public actual val invest_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/invest_icon.png\")") as String, fileName = "invest_icon.png")

    public actual val revert_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/revert_icon.svg\")") as String, fileName = "revert_icon.svg")

    public actual val gbp_circle_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/gbp_circle_flag.png\")") as String, fileName = "gbp_circle_flag.png")

    public actual val call_us: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/call_us.png\")") as String, fileName = "call_us.png")

    public actual val jpy_circle_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/jpy_circle_flag.png\")") as String, fileName = "jpy_circle_flag.png")

    public actual val the_perfect_gift_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/the_perfect_gift_icon.png\")") as String, fileName =
        "the_perfect_gift_icon.png")

    public actual val ic_it_circle: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_it_circle.svg\")") as String, fileName = "ic_it_circle.svg")

    public actual val lv_flag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/lv_flag.svg\")") as String, fileName = "lv_flag.svg")

    public actual val card_status_on_hold: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/card_status_on_hold.png\")") as String, fileName =
        "card_status_on_hold.png")

    public actual val ic_drag_handle: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_drag_handle.svg\")") as String, fileName = "ic_drag_handle.svg")

    public actual val bank_transfer_status_approved: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/bank_transfer_status_approved.png\")") as String, fileName =
        "bank_transfer_status_approved.png")

    public actual val finger_animation_5: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/finger_animation_5.png\")") as String, fileName =
        "finger_animation_5.png")

    public actual val email_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/email_icon.png\")") as String, fileName = "email_icon.png")

    public actual val usd_circle_flag_small: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/usd_circle_flag_small.png\")") as String, fileName =
        "usd_circle_flag_small.png")

    actual override fun values(): List<ImageResource> = listOf(finger_animation_25, sk_flag,
        operation_executed_arrow_image, jcb_circle_logo, pdf_file_img, add_to_gpay_image_it,
        face_id_key, virtual_card_design_012, ee_flag, combobox_arrow_right_gray, chf_circle_flag,
        bus_express_delivery, added_to_icard_pay_image_dark_ro, illustration_side_menu_donations,
        al_flag, add_to_icard_pay_image_el, banner_add_to_apple_pay,
        added_to_icard_pay_image_dark_es, cashterminal_pin_icon, bag_location, horizontal_dots_grey,
        adding_card_ro_dark, add_to_icard_pay_image_fr, cause_round_up_donate_icon, mt_flag,
        card_bottom_sheet_settings_btn, upload_file_camera_icon, adding_card_es_light,
        added_to_icard_pay_image_dark_de, add_bag_tag, password_eye_open, bgn_circle_flag_small,
        business_preview_2, master_card_circle_logo, ic_folder_plus, hrk_circle_flag,
        finger_animation_13, ic_el_circle, added_to_icard_pay_image_bg, insurance_check,
        bank_transfer_icon_sepa_instant, bank_details_icon, pending_request_giftcard_icon,
        fee_transaction_icon, icon_status_check, cz_flag, cant_scan_confirmation_code_image,
        added_to_gpay_image_dark, image_allergens, theme_phone_system, welcome_4,
        adding_card_fr_light, default_circle_flag_small, linked_card_add_new_icon, account_icon_001,
        illustration_side_menu_accounts, add_to_gpay_image_dark_de,
        account_funding_transaction_icon, gr_flag, icon_pending_clock, ic_plus_icon,
        icard_welcome_image_banner, usd_circle_flag, alert_orange_fill_icon,
        safety_online_purchase_icon, add_to_gpay_image_dark, adding_card_ro_light, czk_circle_flag,
        insufficient_funds_image, added_to_gpay_image_nl, split_bill, eye_on_outline_icon,
        ic_check_circle_blue, nav_favorites, protect_icon, add_to_gpay_image_dark_es,
        info_hint_icon_blue, add_to_gpay_image_dark_ro, bank_transfer_status_processing,
        home_top_pick_heart, qr_shimmer, mol_trash_icon, prepaid_icard_white,
        linked_card_maestro_icon, card_status_sent, activity_fill_icon, search_icon, icon_sort,
        rs_flag, loyalty_card_000, adding_card_el_light, cash_withdrawal_transaction_icon,
        success_confirmation_code_image, add_to_gpay_image_de, rating_star_yellow,
        document_fill_icon, navigation_search, map_pin_not_clicked, trustly_logo,
        settings_fill_icon, vpay_circle_logo, benefit_virtual_card_fill_icon, ron_circle_flag_small,
        chrono_icon, added_to_icard_pay_image_nl, merchant_registration_success_illustration,
        bank_transfer_status_declined, adding_card_bg_dark, upload_document_fill_icon,
        card_tab_icon, tap_n_pay_white, welcome_6, donation_transaction_icon, minus_fill_icon,
        contactless_state_2, barcode_icon, ic_folder, card_scheme_logo_visa,
        combobox_arrow_down_gray, watch_fill_icon, visa_prepaid_dark,
        added_to_icard_pay_image_dark_it, insurance_icon, navigation_check, settings_icon,
        arrow_back, card_placeholder, add_to_gpay_image_ro, shopping_discounts_icon, share_icon,
        add_to_gpay_image_es, no_flag, image_authorize_activity_code, ic_de_circle, mk_flag,
        eye_on_fill_icon, help_icon, image_currency_flags, theme_phone_dark, ic_bg_circle,
        visa_prepaid_light, added_to_gpay_image_bg, check_menu_dark, attention_circle_image,
        send_receive_gift_card_icon, star_icon_yellow, support_icon, bank_transfer_icon_sepa,
        get_help_image, tr_flag, finger_animation_27, unfreeze_fill_icon, clock_alert_icon,
        add_money_fill_icon, crop_card_frame_img, location_pin_fill_icon, adding_card_en_dark,
        plastic_GiftCard_details, ic_food_dish, add_to_gpay_image_dark_it, payment_method,
        funds_disbursement_mastercard_logo, heart_favorite, navigation_info, back_arrow_icon,
        virtual_card_frozen_overlay_image, icard_transaction_icon, right_arrow, gallery_fill_icon,
        finger_animation_11, location_tab_details_icon, xk_flag, visa_infinite_logo, ua_flag,
        visa_electron_logo_icon, activate_key_fob_placeholder, donations_side_menu_icon,
        transfer_alert_icon, finger_animation_2, image_bank_funding, ic_ro_circle, web_fill_icon,
        nav_find, red_plus_fab_background, clock_fill_icon, ic_en_circle,
        added_to_gpay_image_dark_de, planet_fill_icon, contactless_icon, card_fee_monthly_img,
        reset_fill_icon, vpay_logo_icon, star_icon, faster_icon, adding_card_de_light, de_flag,
        email_outline_icon, limits_fill_icon, theme_phone_light, chf_circle_flag_small,
        gpay_logo_icon, star_fill_icon, instagram, welcome_2,
        outgoing_bank_transfer_transaction_icon, password_error_icon, remove_icon,
        incomming_bank_transfer_transaction_icon, added_to_gpay_image_dark_es,
        added_to_gpay_image_dark_ro, navigation_switch_user, physical_card_fill_icon, lu_flag,
        lt_flag, contact_phone, add_to_gpay_image, limited_access_offline_warning_image,
        ic_chat_with_us, nav_reservations, eye_off_outline_icon, visa_electron_circle_logo,
        add_bag_gluten_free, fr_flag, finger_animation_19, location_tab_allergens_icon,
        qr_code_icon, illustration_side_menu_cashback_discounts, finger_animation_6,
        ic_dropdown_white, cashback, alert_white_fill_icon, bag_menu_info, nfc_wearable_logo,
        contactless_white, ie_flag, added_to_icard_pay_image_fr, pln_circle_flag_small,
        bank_transfer_icon_bisera, star_6, bank_transfer_status_declined_big, finger_animation_15,
        added_to_icard_pay_image_el, benefit_bank_fill_icon, card_status_processing,
        vignette_transaction_icon, no_permission_contacts_img, adding_card_it_dark, plus_fill_icon,
        finger_animation_23, nfc_fill_icon, checkbox_not_clicked, add_to_icard_pay_image_bg,
        ch_flag, bank_transfer_status_on_hold, renew_fill_icon, add_location_icon, at_flag,
        alert_red_fill_icon, ron_circle_flag, change_design_fill_icon, rating_star_gray,
        illustration_empty_state_cards, camera_1, add_bag_clock, status_on_way, banner_add_to_g_pay,
        exchange_icon, online_purchase_transaction_icon, finger_animation_17, ic_chevron_right_blue,
        added_to_icard_pay_image, buy_bus_ticket_event_icon, finger_animation_8, ic_close_white,
        sm_flag, gbp_circle_flag_small, finger_animation_4, confirm_email_bell_icon,
        image_response_code_success, linked_card_visa_electron_icon, wallet_fill_icon,
        add_to_icard_pay_image, added_to_gpay_image_dark_it, visa_logo, id_fill_icon, ic_file,
        added_to_gpay_image_fr, gift_card_menu_icon, added_to_gpay_image_el,
        virtual_card_design_067, ic_icon_nfc, button_customize, menu_menu_image, rope_outline_icon,
        activate_fill_icon, gift_card_logo, card_fee_annually_img, maestro_circle_logo,
        finger_animation_21, be_flag, visa_logo_white, ic_disabled_wi_fi_icon, contacts_icon,
        add_first_bag_icon, watch_icon, more_icon, ic_icon_nfc_white, contactless_state_4,
        gift_card_the_perfect_gift_dark, img_placeholder, success_activate_card_dialog_image,
        bgn_circle_flag, cashback_event_icon, bet_365_card, add_to_icard_pay_image_nl,
        adding_card_bg_light, concierge_outline_icon, visa_circle_logo,
        pos_purchase_transaction_icon, pending_circle, youtube_icon, new_label_gold,
        hint_3ds_push_image, home_view_map, ru_flag, ic_fr_circle, discounts_outline_icon,
        ic_favorite_icon, meter_fill_icon, padlock_fill_icon, select_icon, dk_flag,
        login_backspace_icon, ic_selection_arrow, bag_menu_pencil, linked_card_mc_icon,
        contactless_state_1, icard_welcome_card_image, home_fill_icon, circle_alert,
        added_to_gpay_image_dark_el, image_response_code_yellow, gift_card_the_perfect_gift_white,
        added_to_gpay_image_dark_fr, open_camera_icon, card_status_approved, added_to_gpay_image_it,
        welcome_5, adding_card_nl_light, success_green_check_with_circle_big, pencil_icon,
        mastercard_logo, mol_edit_icon, camera_icon, sepa_fill_icon, cash_outline_icon,
        image_premium_card, hr_flag, loyalty_card_menu_icon, add_to_gpay_image_dark_bg,
        adding_card_fr_dark, star_express_delivery, bank_transfer_icon_blink,
        plastic_gift_card_design_020, virtual_card_design_037, added_to_icard_pay_image_dark,
        business_preview_3, bank_transfer_status_processing_big, added_to_icard_pay_image_dark_bg,
        prepaid_icard, giftcard_the_perfect_gift_logo_white, copy_icon, finger_animation_1,
        add_to_gpay_image_nl, tap_and_pay_nfc_disabled_icon, facebook_color, progress_image,
        close_icon, avatar_fill_icon, check_fill_icon, illustration_side_menu_e_buss_ticket,
        added_to_icard_pay_image_de, online_payment_outlined_icon, ro_flag, mc_flag,
        finger_animation_12, info_fill_icon, no_results_found_image, ic_restaurant_menu,
        loyalty_card_back_default, bag_menu_trash, ic_add_money, biometric_lock_icon,
        added_to_icard_pay_image_ro, pending_request_bitpanda_icon, added_to_icard_pay_image_es,
        withdraw_fill_icon, upload_document_outlined_icon, finger_animation_24, bank_fill_icon,
        es_flag, discount_successfully_activate_card_img, jpy_circle_flag_small,
        finger_animation_28, order_plastic_giftcard_transaction_icon, map_pin_clicked,
        cashterminal_locations, staff_edit_icon, nl_flag, adding_card_nl_dark, ad_flag,
        add_bag_shopping_bag, visa_click_to_pay_whats_new, cy_flag, finger_animation_10,
        infinite_prepaid_card, image_online_payment, crop_card_plastic_gift_frame_img, whatsapp,
        added_to_gpay_image_es, added_to_gpay_image_ro, ic_es_circle, finger_animation_3,
        utility_bills_transaction_icon, ic_camera_image, illustration_side_menu_premium_cards,
        merchant_tab_bags, adding_card_it_light, business_preview_1, add_to_gpay_image_dark_nl,
        card_bottom_sheet_activity_btn, shield_icon, phone_fill_icon, send_us_email,
        ic_chevron_left, added_to_gpay_image_de, activate_card_arrow_white, profile_default_image,
        checkbox_not_clicked_web, it_flag, cashterminal_logo, finger_animation_26, ic_airplane_icon,
        round_up_icon_small, pl_flag, add_money_via_bank_icon, ic_copy_iban, avatar_image_frame,
        ic_cross_filled, home_top_pick_star, tap_n_pay_black, phone_outline_icon, eur_circle_flag,
        si_flag, camera_outlined_icon, contactless_state_3, bin_fill_icon, location_tab_menu_icon,
        error_image, round_up_hint_image, ic_arrow_down, freeze_fill_icon, visa_logo_new,
        sent_payment_transaction_icon, added_to_icard_pay_image_it, apple_pay_event_logo_icon,
        youtube, image_card_payment, redeem_funds_transaction_icon, add_to_gpay_image_bg,
        transp_flag, info_grey_fill_icon, added_to_icard_pay_image_dark_nl, sms_icon, fi_flag,
        location_tab_business_icon, warning_outline_icon, expiry_alert_icon,
        illustration_side_menu_giftcard, print_icon, metal_prepaid_card, rate_us_image,
        click_to_pay_icon, success_green_arrow_with_circle, combobox_arrow_down_green, welcome_7,
        location_fill_icon, umbrella_outline_icon, gift_card_design_000, ic_phone_settings_icon,
        ba_flag, gpay_event_logo_icon, maestro_logo_icon, nav_account, finger_animation_22,
        contact_mail, image_card_funding_applepay, virtual_card_design_068, linked_card_jcb_icon,
        close_button, se_flag, li_flag, add_to_icard_pay_image_de, benefit_clock_fill_icon,
        ic_internet_connection_icon, check_email_image, adding_card_de_dark, navigation_cash_pin,
        total_to_pay, tax_payment_icon, password_eye_closed, information_icon, finger_animation_7,
        is_flag, finger_animation_18, mastercard_logo_new, added_to_icard_pay_image_dark_fr,
        circle_important_fill_icon, add_to_icard_pay_image_ro, add_to_icard_pay_image_es,
        image_card_funding_gpay, added_to_icard_pay_image_dark_el, visa_debit_logo_white,
        bag_collect, finger_animation_14, combobox_arrow_right_green, dropdown_dots, ic_folder_open,
        navigation_settings, location_tab_location_icon, sleek_icon, cast_icon, slider_thumb,
        ic_dropdown_black, welcome_3, add_money_via_gpay_icon, illustration_side_menu_vignettes,
        fees_and_limits_icon, filter_icon, linked_card_visa_icon, ic_chevron_right,
        add_to_gpay_image_dark_fr, verify_identity_outline_icon, add_to_gpay_image_dark_el,
        navigation_back, navigation_close, czk_circle_flag_small, default_pin, ic_nl_circle,
        virtual_card_fill_icon, scan_fill_icon, added_to_gpay_image_dark_bg, bg_flag,
        navigation_chat, cirlce_info_fill_icon, qr_transaction_icon, warning_icon_with_triangle,
        login_fingerprint_icon, bank_transfer_icon_swift, illustration_side_menu_insurances,
        web_language_chevron, add_to_gpay_image_el, checkbox_clicked, navigation_authorize,
        add_to_gpay_image_fr, home_view_grid, visa_infinite_gold_logo,
        illustration_side_menu_utility_bills, easy_to_use_icon, card_top_up_transaction_icon,
        by_flag, add_to_icard_pay_image_it, exclamation_info_icon, ic_check_filled_green,
        merchant_tab_locations, navigation_support, welcome_1, medical_shield_fill_icon, gb_flag,
        ic_arrow_up, benefit_debit_card_fill_icon, lock_fill_icon, code_input_fill_icon,
        ic_check_filled_blue, top_up_transaction_icon, non_eaa_check, qr_fill_icon, trasnfer_icon,
        plane_fill_icon, fees_service_fee, hrk_circle_flag_small, added_to_gpay_image,
        eur_circle_flag_small, pln_circle_flag, order_fill_icon, jcb_logo_icon, hu_flag,
        contacts_fill_icon, cashterminal_header, adding_card_el_dark, linked_card_vpay_icon,
        va_flag, transfer_type_placeholder_icon, camera_fill_icon, pt_flag, me_flag,
        contactless_fill_icon, md_flag, choose_consent_image, barcode_frame, heart_fill_icon,
        transfers_fill_icon, navigation_filter, finger_animation_20, mobile_number_tab_icon,
        added_to_gpay_image_dark_nl, blocked_illustration, adding_card_en_light,
        visa_debit_logo_dark, finger_animation_9, adding_card_es_dark, bag_age_restricted_18,
        finger_animation_16, invest_icon, revert_icon, gbp_circle_flag, call_us, jpy_circle_flag,
        the_perfect_gift_icon, ic_it_circle, lv_flag, card_status_on_hold, ic_drag_handle,
        bank_transfer_status_approved, finger_animation_5, email_icon, usd_circle_flag_small)
  }

  public actual object fonts : ResourceContainer<FontResource> {
    actual override val __platformDetails: ResourcePlatformDetails = ResourcePlatformDetails()

    public actual val google_sans_semibold: FontResource = FontResource(fileUrl =
        js("require(\"./fonts/google_sans_semibold.ttf\")") as String, fontFamily =
        "google_sans_semibold")

    public actual val carossoft_medium: FontResource = FontResource(fileUrl =
        js("require(\"./fonts/carossoft_medium.otf\")") as String, fontFamily = "carossoft_medium")

    public actual val carossoft: FontResource = FontResource(fileUrl =
        js("require(\"./fonts/carossoft.otf\")") as String, fontFamily = "carossoft")

    public actual val carossoft_light: FontResource = FontResource(fileUrl =
        js("require(\"./fonts/carossoft_light.otf\")") as String, fontFamily = "carossoft_light")

    public actual val google_sans_medium: FontResource = FontResource(fileUrl =
        js("require(\"./fonts/google_sans_medium.ttf\")") as String, fontFamily =
        "google_sans_medium")

    public actual val google_sans_bold: FontResource = FontResource(fileUrl =
        js("require(\"./fonts/google_sans_bold.ttf\")") as String, fontFamily = "google_sans_bold")

    public actual val carossoft_bold: FontResource = FontResource(fileUrl =
        js("require(\"./fonts/carossoft_bold.otf\")") as String, fontFamily = "carossoft_bold")

    public actual val google_sans_regular: FontResource = FontResource(fileUrl =
        js("require(\"./fonts/google_sans_regular.ttf\")") as String, fontFamily =
        "google_sans_regular")

    public actual val carossoft_extralight: FontResource = FontResource(fileUrl =
        js("require(\"./fonts/carossoft_extralight.otf\")") as String, fontFamily =
        "carossoft_extralight")

    actual override fun values(): List<FontResource> = listOf(google_sans_semibold,
        carossoft_medium, carossoft, carossoft_light, google_sans_medium, google_sans_bold,
        carossoft_bold, google_sans_regular, carossoft_extralight)

    public fun addFontsToPage() {
      js("require(\"./fonts/comexamplemystybagcoreresources-generated-declarations.css\")")
    }
  }
}
